import { useUpdateProviderMutation, Provider } from '../../../../graphql'
import useShowSuccess from 'hooks/useShowSuccess'

export default function useUpdateProviderHandler() {
	const [ updateProviderMutation ] = useUpdateProviderMutation()
	const showSuccess = useShowSuccess()

	return async( provider: Provider ) => {
		await updateProviderMutation( {
			variables: {
				providerId: provider.id,
				name: provider.name,
			},
		} )
		showSuccess( `updateProviderSuccess${Date.now()}`, 'Successfully updated manufacturer!' )
	}
}
